// extracted by mini-css-extract-plugin
export default {"editorWrapper":"VQ2gm","form":"ckSBx","input":"uYHkG","label":"W7YiJ","editBtnWrapper":"WhZQu"};